import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const DeliveryButton = ({ clickHandler, icon }) => {
    return (<OptionButton
        iconClass={`fa fa-fw ${icon}`}
        clickHandler={clickHandler}
        title={t('options.fileDelivery')}
        noChildren
    />);
};

DeliveryButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    icon: PropTypes.string,
};

function mapStateToProps(state) {
    return { icon: state.ui.variables.options__fileDeliveryIcon };
}

const FileDeliveryButton = connect(mapStateToProps)(DeliveryButton);

export default FileDeliveryButton;
